import { Box, useTheme } from '@mui/material';

interface RiskLevelLabelProps {
  primaryColor?: string;
  secondaryColor?: string
  riskLevelName?: string;
}

export function RiskLevelLabel({ primaryColor, secondaryColor, riskLevelName }: RiskLevelLabelProps) {

    if (!riskLevelName || !primaryColor || !secondaryColor) return null;

    return (
        <Box
        sx={{
            backgroundColor: secondaryColor,
            color: primaryColor,
            fontSize: '0.75rem',
            borderRadius: '999px',
            padding: '2px 12px',
            fontWeight: 'bold',
            border: `1px solid ${primaryColor}`,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
        }}
        >
        {riskLevelName}
        </Box>
    );
}